import { FC, HTMLAttributes } from 'react';

import styles from './SearchButton.module.css';

type SearchButtonType = HTMLAttributes<HTMLButtonElement> & {
  size?: 24 | 'auto' | 'chip';
};
const SearchButton: FC<SearchButtonType> = ({ children, size = 24, ...buttonProps }) => {
  return (
    <button tabIndex={0} className={[styles.searchButton, styles[`searchButton${size}`]].join(' ')} {...buttonProps}>
      {children}
    </button>
  );
};
export default SearchButton;
